import { Injectable } from '@angular/core';
import * as Cookies from 'js-cookie';

@Injectable({
    providedIn: 'root'
})
export class ConstantsService {

    // Used for I18N, dictates which languages are available to the app
    public static SUPPORTED_LOCALES = [
        {label: 'English (AU)', key: 'en-au'},
        {label: 'English (US)', key: 'en-us'},
        {label: 'Español (US)', key: 'es-us'},
        {label: 'Français (CA)', key: 'fr-ca'},
    ];
    public static LOCALE_TOKEN = 'xref-chosen-locale';
    public static AUTH_TOKEN = 'xrefauthtoken';
    public static AUTH_DOMAIN_WHITELIST = [
        new RegExp(/^[a-zA-Z0-9-\.]*\.?xref\.com$/),
        'localhost:8000',
        '127.0.0.1:8000',
        'localhost:8001',
        '127.0.0.1:8001',
        'localhost:8003',
        '127.0.0.1:8003',
    ];

    constructor() {};
}
